import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Grid } from '@mui/material'
import { CSSProperties } from 'react'
import { Courses } from '../../models/course'
import CourseCard from './CourseCard'

interface DraggableCourseItemProps {
  course: Courses
  isMobile?: boolean
  isTablet?: boolean
}

const DraggableCourseItem = ({ course, isMobile }: DraggableCourseItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: course.id })

  const dragStyle: CSSProperties = {
    transform: transform ? CSS.Transform.toString(transform) : undefined,
    transition: transition || 'none',
    opacity: isDragging ? 0.8 : 1,
    position: 'relative',
    zIndex: isDragging ? 1000 : 1,
    cursor: isDragging ? 'grabbing' : 'grab'
  }

  const MoveIndicator = () => (
    <div
      style={{
        position: 'absolute',
        top: '8px',
        right: '8px',
        zIndex: 2,
        background: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '4px',
        padding: '4px 8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        pointerEvents: 'none'
      }}
    >
      <span style={{ color: '#666', fontSize: '16px' }}>⋮⋮{!isMobile && ' Mover'}</span>
    </div>
  )

  return (
    <Grid item className="websiteCourse" ref={setNodeRef} style={dragStyle} {...attributes} {...listeners}>
      <MoveIndicator />
      <div
        style={{
          filter: isDragging ? 'brightness(0.95)' : 'none',
          transform: isDragging ? 'scale(1.02)' : 'none',
          transition: 'all 0.2s ease'
        }}
      >
        <CourseCard course={course} />
      </div>
    </Grid>
  )
}

export default DraggableCourseItem
